import {
    Box,
    Divider,
    Typography,
} from "@mui/material";
import { COLORS } from "../screens/dashboard/epis-dashboard/configs/config";
export default function SectionTitle({ title, subtitle }) {
    return (
        <Box sx={{ mt: 4, mb: 1.5 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: COLORS.tPri }}>{title}</Typography>
            {subtitle && <Typography variant="body2" sx={{ color: COLORS.tDim }}>{subtitle}</Typography>}
            <Divider sx={{ mt: 1, borderColor: COLORS.border , mb:3}} />
        </Box>
    );
}